import { render } from "./LocalReportStep2.vue?vue&type=template&id=5948ad40&ts=true"
import script from "./LocalReportStep2.vue?vue&type=script&lang=ts"
export * from "./LocalReportStep2.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__